module.exports = __webpack_public_path__ + "3f16e137/img/dollar-icon.35c9d638.svg";